import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import { FaDownload, FaExpand, FaTrashCan } from 'react-icons/fa6';
import { format } from 'date-fns';
import { CRUD_PERMISSIONS, RESTRICT_ASSIGN_ROLES, USER_ROLES } from "../constants/user";
import GSTR1SheetModal from './GSTR1SheetModal';
import RefundsSheetModal from './refund/RefundsSheetModal';
import useCheckAuthorization from "../hooks/checkAuthorization";
import GSTR3bSheetModal from './gstr3b/GSTR3bSheetModal';
import { useSelector } from 'react-redux';
import SheetSubmitSkipModal from './common/SheetSubmitSkipModal';

const ViewSheetSummary = ({sheetSummaryData, handleSheetSubmit, handleSheetSubmitManager, sheetType, getSheet, periodId, hadleDeleteSheet, approverLevels, handleSkipSubmit}) => {

  const [showSheetModal, setShowSheetModal] = useState(false);
  const [viewOnlySheetData, setViewOnlySheetData] = useState(null);
  //const manageAllClientsPermission = useCheckAuthorization(CRUD_PERMISSIONS.sheet.manage_clients);
  const [showSkipModal, setShowSkipModal] = useState(false);
  const { role_id: roleId} = useSelector(state => state.common);

  // Check if any key equals roleId with progress: 0
  const hasRoleWithZeroProgress = Object.entries(approverLevels).some(
      ([key, role]) => parseInt(key) === roleId && role.progress === 0
  );
  // Check if any keys are less than or equal to roleId
  const hasKeysLessThanRoleId = Object.keys(approverLevels).some(key => parseInt(key) <= roleId);

  // Check if all lesser keyed objects have progress of 0
  const allLesserKeysHaveZeroProgress = Object.entries(approverLevels).every(
      ([key, role]) => parseInt(key) >= roleId || role.progress === 0 
  );

  // Check if the directors' progress is 0 when roleId is admin
  const isDirectorsProgressZero = roleId === USER_ROLES.admin 
  ? approverLevels["1"]?.progress === 0 
  : true; // True if not admin to satisfy the condition

  // Determine if hasSubmitAccess
  const hasSubmitAccess = 
    Object.keys(approverLevels).every(k => parseInt(k) > roleId) || 
    (hasKeysLessThanRoleId && hasRoleWithZeroProgress && allLesserKeysHaveZeroProgress && isDirectorsProgressZero) || sheetSummaryData?.sheet?.status === 0;
                      
  console.log('hasSubmitAccess', hasSubmitAccess);
  
  const getStatus = () => {
    if(sheetSummaryData?.sheet?.status === 0)
      return "";
    for (const key of Object.keys(approverLevels).sort((a, b) => a - b)) {
      const role = approverLevels[key];
  
      // If progress is 1, return approved by the corresponding role
      if (role.progress === 1) {
        switch (key) {
          case "1":
            return "Submitted by Director";
          case "2":
            return "Submitted by Manager";
          case "3":
            return "Submitted by Sr associate";
          case "4":
            return "Submitted by Associate";
          default:
            return "Unknown approver";
        }
      }
  
      // If progress is 3, return the smallest key (i.e., role) that was skipped
      if (role.progress === 3) {
        switch (key) {
          case "1":
            return "Skipped by Director";
          case "2":
            return "Skipped by Manager";
          case "3":
            return "Skipped by Sr associate";
          case "4":
            return "Skipped by Associate";
          default:
            return "Unknown skipped role";
        }
      }
    }
    return "";
  };
  const handleSheetShow = (sheetData) => {
    if(sheetData){
      setViewOnlySheetData(sheetData);
    }else{
      setViewOnlySheetData(null);
    }
    setShowSheetModal(true);
  }
  const handleSheetClose = async () => {
    await getSheet(periodId);
    setShowSheetModal(false);
  }

  const handleSkipClose  = async () => {
    setShowSkipModal(false);
  }

  const resolvedComments = sheetSummaryData?.all_comments.filter(comment =>  comment.status === 4);
  return (
    <>
      <ul className="list-group list-group-flush r-list-group sheet-summary-list-group">
        {sheetSummaryData?.sheet &&  
          <li class="list-group-item">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <i className="las la-file-excel pa-text-success mx-2"></i>
                {sheetSummaryData.sheet.file_name}
              </div>
              <div className="d-flex align-items-center">
                {/* View Button with Icon */}
                <a href="#" className="p-0 mx-2 text-sm d-flex align-items-center cursor-pointer" onClick={() => handleSheetShow()}>
                  View <FaExpand className="ml-1" /> {/* Icon aligned to the right of View text */}
                </a>
                <span className="mx-1">|</span>
                
                {/* Download Button with Icon */}
                <a href={sheetSummaryData.sheet.url} target="_blank" rel="noreferrer" className="p-0 mx-2 text-sm d-flex align-items-center">
                  Download <FaDownload className="ml-1" /> {/* Icon aligned to the right of Download text */}
                </a>
                <span className="mx-1">|</span>
                
                {/* Approval Status */}
                {sheetSummaryData.sheet.status === 1 && sheetSummaryData.sheet.client_approval === 1 && sheetSummaryData.sheet.preface_approval === 1 && 
                  <span className="text-sm">Approved</span>
                }
                {sheetSummaryData.sheet.status === 2 && sheetSummaryData.sheet.client_approval === 1 && 
                  <>
                  <span className="text-sm">Rejected</span>
                  <span className="mx-1">|</span>
                  </>
                }
                {!hasSubmitAccess && ((sheetSummaryData.sheet.status === 3 && sheetSummaryData.sheet.preface_approval === 1) || ((sheetSummaryData.sheet.status === 2 || sheetSummaryData.sheet.status === 1) && sheetSummaryData.sheet.client_approval === 0 )) ? 
                  <span className="text-sm">Waiting For Client Approval </span> : <span className="text-sm">{getStatus() ? getStatus() : ''}</span>
                }
                {hasSubmitAccess && ((sheetSummaryData.sheet.status === 0 && (sheetSummaryData.sheet.preface_approval === 0 || sheetSummaryData.sheet.preface_approval === 1)) || (sheetSummaryData.sheet.status === 2 && sheetSummaryData.sheet.client_approval === 1)  ) && 
                  <>
                  {getStatus() && <span className="mx-1">|</span>}
                  <Button type="button" variant="primary" size="sm" onClick={() => handleSheetSubmit(sheetSummaryData.sheet.id, 4)}>Submit for Client Approval</Button>
                  {!RESTRICT_ASSIGN_ROLES.includes(roleId) &&
                    <>
                    <span className="mx-1">|</span>
                    <Button type="button" variant="outline-primary" size="sm" onClick={() => setShowSkipModal(true)}>Skip to next level</Button>
                    </>
                  }
                  
                  </>
                }

                {/* Manager */}
                  {hasSubmitAccess && sheetSummaryData.sheet.preface_approval === 0 && sheetSummaryData.sheet.status === 3 && 
                  (
                    <>
                    {
                     
                      <span className="mx-1">|</span>
                    
                    }
                    
                    <Button type="button" variant="primary" size="sm" onClick={() => handleSheetSubmitManager(sheetSummaryData.sheet.id, 1)}>Confirm</Button> 
                    <span className="mx-1">|</span>
                    <Button type="button" variant="outline-primary" size="sm" onClick={() => handleSheetSubmitManager(sheetSummaryData.sheet.id, 2)}>Deny</Button>
                    </>
                  )}
                
              </div>
            </div>
            <div className="d-flex align-items-left mt-2">
              {sheetSummaryData.sheet.updated_date && <>
                <small>{format(sheetSummaryData.sheet.updated_date, 'dd-MM-yyyy')}</small>
                <small className="mx-1">|</small>
              </>}
              <small>({sheetSummaryData.all_comments.length}) Comments</small>
              <small className="mx-1">|</small>
              <small>({resolvedComments.length}) Resolved</small>
            </div>
          </li>
        }
        {sheetSummaryData?.allSheet?.map((sheetData, i) => {
            return (
              <li className="list-group-item" key={i+1}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <i className="las la-file-excel pa-text-success mx-2"></i>
                    {sheetData.file_name}
                  </div>
                  <div className="d-flex align-items-center">
                    {/* View Button with Icon */}
                    <a href="#" className="p-0 mx-2 text-sm d-flex align-items-center cursor-pointer" onClick={() => handleSheetShow(sheetData)}>
                      View <FaExpand className="ml-1" /> {/* Icon aligned to the right of View text */}
                    </a>
                    <span className="mx-1">|</span>
                    
                    {/* Download Button with Icon */}
                    <a href={sheetData.url} target="_blank" rel="noreferrer" className="p-0 mx-2 text-sm d-flex align-items-center">
                      Download <FaDownload className="ml-1" /> {/* Icon aligned to the right of Download text */}
                    </a>
                    <span className="mx-1">|</span>
                    <a href="#" onClick={() => hadleDeleteSheet(sheetData.id)} className="p-0 mx-2 text-sm d-flex align-items-center">
                      Delete <FaTrashCan className="ml-1" /> {/* Icon aligned to the right of Download text */}
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-left mt-2">
                  {sheetData.updated_date && <small>{format(sheetData.updated_date, 'dd-MM-yyyy')}</small>}
                </div>
              </li>
            )
        })}
      </ul>
      
      {sheetType === 'gstr3b' && 
      <GSTR3bSheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} getStatus={getStatus} hasSubmitAccess={hasSubmitAccess} showSkipModal={showSkipModal} handleSkipClose={handleSkipClose} handleSkipSubmit={handleSkipSubmit} setShowSkipModal={setShowSkipModal} />}
      {sheetType === 'gstr1' && 
      <GSTR1SheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} getStatus={getStatus} hasSubmitAccess={hasSubmitAccess} showSkipModal={showSkipModal} handleSkipClose={handleSkipClose} handleSkipSubmit={handleSkipSubmit} setShowSkipModal={setShowSkipModal}/>}
      {sheetType === 'refunds' && 
      <RefundsSheetModal showSheetModal={showSheetModal} handleSheetClose={handleSheetClose} handleSheetSubmit={handleSheetSubmit} handleSheetSubmitManager={handleSheetSubmitManager} sheetSummaryData={sheetSummaryData} viewOnlySheetData={viewOnlySheetData} periodId={periodId} getStatus={getStatus} hasSubmitAccess={hasSubmitAccess} showSkipModal={showSkipModal} handleSkipClose={handleSkipClose} handleSkipSubmit={handleSkipSubmit} setShowSkipModal={setShowSkipModal} />}
      <SheetSubmitSkipModal showSkipModal={showSkipModal} handleSkipClose={handleSkipClose} handleSkipSubmit={handleSkipSubmit}/>
    </>
  )
}

export default ViewSheetSummary
